import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsSalesByProductQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsSalesByProductTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsSalesByProductQuery({
    variables: { filter: filter as never, limit },
  });

  const rows = (data?.analyticsSales.salesByProduct ?? []).map((row) => [
    row.title,
    formatNumber(row.sales),
    formatCurrency(row.revenue, data?.analyticsSales.currency ?? "USD"),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.sales.tableByProduct")}
      columns={[
        { name: t("analytics.sales.columnProduct"), minWidth: 200 },
        { name: t("analytics.sales.columnSales") },
        { name: t("analytics.sales.columnRevenue") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.SalesByProductType}
          filter={filter}
        />
      }
    />
  );
};
